export const assets = (imageFileName) => {
    return {
        image: require(`assets/${imageFileName}.png`),
        image2x: require(`assets/${imageFileName}@2x.png`),
        image3x: require(`assets/${imageFileName}@3x.png`),
    };
};
